import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { DEFAULT_PROVIDER } from "../../MacroIcon/Icon";
import { iconsService } from "../../MacroIcon/iconsService";
import SelectProviders from "./SelectProviders";
import { SidebarIconsContext } from "./Context";
import Icons from "./Icons";

function SidebarIconPicker({ icon, onIconSelect }) {
  const [selectedProvider, setSelectedProvider] = useState();
  const [searchTerm, setSearchTerm] = useState(window.searchTerm || "");
  const [isLoading, setIsLoading] = useState(true);

  const selectProvider = (providerKey) => {
    setSelectedProvider(providerKey);

    if (!window.iconSets.find((s) => s.provider === providerKey)) {
      setIsLoading(true);

      iconsService
        .fetchIcons(providerKey)
        .then(({ data }) => {
          window.iconSets.push({ provider: providerKey, icons: data });
        })
        .finally(() => setIsLoading(false));
    }
  };

  const contextProps = {
    selectedProvider,
    searchTerm,
    isLoading,

    setSelectedProvider,
    setSearchTerm,
    setIsLoading,

    onIconSelect,
    selectProvider,
  };

  useEffect(() => {
    window.iconSets = [];
    selectProvider(DEFAULT_PROVIDER);
  }, []);

  return (
    <SidebarIconsContext.Provider value={{ ...contextProps }}>
      <SelectProviders />
      <Icons selected={icon} />
    </SidebarIconsContext.Provider>
  );
}

SidebarIconPicker.defaultProps = {
  icon: null,
};

SidebarIconPicker.propTypes = {
  onIconSelect: PropTypes.func.isRequired,
  icon: PropTypes.string,
};

export default SidebarIconPicker;
